let cache = null;

export default function fetchLocation() {
  if (cache) {
    return cache;
  }

  cache = fetch(`https://api.ipgeolocation.io/v3/ipgeo?apiKey=${window.api.public_guides_ip_key}&fields=location`, {
    method: "GET",
    redirect: "follow",
  })
    .then((response) => response.json())

  return cache;
}
